// After
import { createRoot } from 'react-dom/client';
import Root from './components/Root'
import './design-utils/variables.scss'
const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<Root tab="home" />);


// new content
//const rootElement = document.getElementById("root");
//if (rootElement.hasChildNodes()) {
//  hydrate(<Root />, rootElement);
//} else {
//  render(<Root />, rootElement);
//}
